module.exports = {
  purge: {
    // Manually purging
    enabled: false,
  },
  theme: {
    fontFamily: {
      body: ["'RM Neue'", "'Helvetica'", "'Arial'"],
    },
    fontSize: {
      1: '2.375rem', // 38
      2: '1.75rem', // 28
      3: '1.313rem', // 21
      4: '1rem', // 16
    },
    colors: {
      black: '#000000',
      white: '#FFFFFF',
      gray: '#F0F0F0',
      red: '#FF0000',
      theme1: '#23a4e6',
    },
    borderRadius: {
      none: '0',
      tight: '0.5rem',
      wide: '1.5rem',
      full: '9999px',
      input: '0.25rem',
    },
    extend: {
      maxWidth: {
        64: '16rem',
      },
      minWidth: {
        sm: '24rem',
      },
    },
  },
  variants: {},
  plugins: [],
};
